import { populate } from 'populate'; import dragonBones from 'pixi-dragonbones';

const raw = {
  className: '',
  width: 640,
  height: 960,
  x: 0,
  y: 0,
  list: [
    {
      id: '7b68d14a-9c88-44d0-8870-412404229e19',
      type: 'Container',
      name: 'root',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '',
      data: ''
    },
    {
      id: 'b12a6fbd-d8b7-438c-9d94-072fb869a18a',
      type: 'NineSlicePlane',
      name: 'ProgressBar',
      nameSpace: '',
      className: '',
      x: 70,
      y: 160,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      width: 2240,
      height: 24,
      leftWidth: 20,
      topHeight: 0,
      rightWidth: 20,
      bottomHeight: 0,
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'seasonpass_progress_bar_back',
      parent: '7b68d14a-9c88-44d0-8870-412404229e19',
      data: ''
    },
    {
      id: '53abf1bd-0f7f-4b99-8ac8-f0399287730e',
      type: 'NineSlicePlane',
      name: 'ProgressBarFill',
      nameSpace: '',
      className: '',
      x: 1,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      width: 2240,
      height: 24,
      leftWidth: 20,
      topHeight: 0,
      rightWidth: 20,
      bottomHeight: 0,
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'seasonpass_progress_bar_green',
      parent: 'b12a6fbd-d8b7-438c-9d94-072fb869a18a',
      data: ''
    },
    {
      id: '8c16ab27-edf1-459e-ba29-8ff1e0e0c78b',
      type: 'NineSlicePlane',
      name: 'ProgressBarFrontSprite',
      nameSpace: '',
      className: '',
      x: 1,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      width: 2240,
      height: 24,
      leftWidth: 20,
      topHeight: 0,
      rightWidth: 20,
      bottomHeight: 0,
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'seasonpass_progress_bar_front',
      parent: 'b12a6fbd-d8b7-438c-9d94-072fb869a18a',
      data: ''
    },
    {
      id: '56a56348-96db-4e34-a295-c878b47b1ecf',
      type: 'Container',
      name: 'Tractor',
      nameSpace: '',
      className: '',
      x: 0,
      y: 12,
      anchor: {
        x: 0.25,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'b12a6fbd-d8b7-438c-9d94-072fb869a18a',
      data: ''
    }
  ],
  version: '1.0.x'
} as const;

export class SeasonPassRankProgress {
  static raw = raw;
  root: PIXI.Container
  ProgressBar: PIXI.NineSlicePlane
  ProgressBarFill: PIXI.NineSlicePlane
  ProgressBarFrontSprite: PIXI.NineSlicePlane
  Tractor: PIXI.Sprite

  constructor() {
    populate(this, raw);
  }
}
